export const smoothScrollTo = (section: string, scrollOptions?: ScrollIntoViewOptions) => {
  const target = document.querySelector(`[data-section="${section}"]`)
  target?.scrollIntoView({ behavior: 'smooth', ...scrollOptions })
}
